<aside
  class="hidden sm:flex sm:h-full max-h-full overflow-y-auto min-w-3xs max-w-2xs flex-col"
>
  <menu class="space-y-1!">
    <h3 class="collapse-title font-semibold py-1 text-lg">
      {{ 'Sub Categories' | translate }}
    </h3>
    <button
      class="collapse-title text-start font-semibold py-1"
      [routerLink]="['/categories', categorySlug()]"
      [queryParams]="preservedQueryParams()"
    >
      {{ 'Show All' | translate }}
    </button>
    <ul class="flex flex-col items-stretch text-start text-white-dark-a">
      @for (item of subCategories().slice(0, 7); track item.id) {
        <li class="collapse" [class.collapse-arrow]="item.children.length">
          <input type="checkbox" class="py-px w-8 ms-auto" />
          <button
            [routerLink]="['/categories', categorySlug(), item.slug]"
            [queryParams]="preservedQueryParams()"
            class="collapse-title font-semibold text-start py-px hover:text-blue"
            [class.text-blue]="
              isFilteredBy(item.id) || isParentFilteredBySlug(item.slug)
            "
          >
            {{ item.name }}
          </button>
          @if (item.children.length) {
            <div class="collapse-content text-base flex flex-col pb-1">
              @for (child of item.children; track child.id) {
                <button
                  [routerLink]="[
                    '/categories',
                    categorySlug(),
                    item.slug,
                    child.slug,
                  ]"
                  [queryParams]="preservedQueryParams()"
                  class="text-start ps-5 hover:text-blue"
                  [class.text-blue]="isFilteredBy(child.id)"
                >
                  {{ child.name }}
                </button>
              }
            </div>
          }
        </li>
      }
      @if (viewMoreSubs() && subCategories().length > 7) {
        @for (item of subCategories().slice(7); track item.id) {
          <li class="collapse" [class.collapse-arrow]="item.children.length">
            <input type="checkbox" class="py-px" />
            <button
              [routerLink]="['/categories', categorySlug(), item.slug]"
              [queryParams]="preservedQueryParams()"
              class="collapse-title font-semibold text-start py-px hover:text-blue"
              [class.text-blue]="
                isFilteredBy(item.id) || isParentFilteredBySlug(item.slug)
              "
            >
              {{ item.name }}
            </button>
            @if (item.children.length) {
              <div class="collapse-content text-base flex flex-col pb-1">
                @for (child of item.children; track child.id) {
                  <button
                    [routerLink]="[
                      '/categories',
                      categorySlug(),
                      item.slug,
                      child.slug,
                    ]"
                    [queryParams]="preservedQueryParams()"
                    class="text-start ps-5 hover:text-blue"
                    [class.text-blue]="isFilteredBy(child.id)"
                  >
                    {{ child.name }}
                  </button>
                }
              </div>
            }
          </li>
        }
      }
    </ul>
    @if (subCategories().length > 7) {
      <button
        class="collapse-title py-1 font-normal text-red underline underline-offset-1 text-start"
        (click)="toggleViewMoreSubs()"
      >
        {{ viewMoreSubs() ? ('View Less' | translate) : ('View More' | translate) }}
      </button>
    }
  </menu>
  <menu>
    <div class="collapse collapse-arrow">
      <input type="checkbox" class="py-1" checked="true" />
      <div class="collapse-title font-bold">{{ 'Brand' | translate }}</div>
      <div class="collapse-content text-sm">
        <fieldset class="flex flex-col space-y-2">
          @for (brand of brands().slice(0, 7); track brand.id) {
            <label class="label text-base items-center text-black">
              <input
                type="checkbox"
                [checked]="brandIsChecked(brand.id)"
                class="checkbox checkbox-primary checkbox-sm rounded"
                (change)="toggleBrandFilterOption(brand.id)"
              />
              {{ brand.name }} ({{ brand.productCount }})
            </label>
          }
          @if (viewMoreBrands() && brands().length > 7) {
            @for (brand of brands().slice(7); track brand.id) {
              <label class="label text-base items-center text-black">
                <input
                  type="checkbox"
                  [checked]="brandIsChecked(brand.id)"
                  class="checkbox checkbox-primary checkbox-sm rounded"
                  (change)="toggleBrandFilterOption(brand.id)"
                />
                {{ brand.name }} ({{ brand.productCount }})
              </label>
            }
          }
        </fieldset>
      </div>
    </div>
    @if (brands().length > 7) {
      <button
        class="collapse-title py-1 font-normal text-red underline underline-offset-1 text-start"
        (click)="toggleViewMoreBrands()"
      >
        {{ viewMoreBrands() ? ('View Less' | translate) : ('View More' | translate) }}
      </button>
    }
  </menu>
  <!-- Temporarily hidden per TechLead decision.
    <menu class="collapse collapse-arrow">
      <input type="checkbox" checked="true" />
      <div class="collapse-title font-bold">
        {{ 'Service & Promotions' | translate }}
      </div>
      <div class="collapse-content text-sm">
        <fieldset class="flex flex-col space-y-2">
          <label class="label text-base items-center">
            <input
              type="checkbox"
              [checked]="freeDeliveryChecked()"
              class="checkbox checkbox-primary checkbox-sm rounded"
              (change)="toggleFreeDeliveryFilter()"
            />
            {{ 'Free Delivery' | translate }}
          </label>
          <label class="label text-base items-center">
            <input
              type="checkbox"
              [checked]="newItemsChecked()"
              class="checkbox checkbox-primary checkbox-sm rounded"
              (change)="toggleNewItemsFilter()"
            />
            {{ 'New Items' | translate }}
          </label>
        </fieldset>
      </div>
    </menu>
  -->
  <fieldset class="mt-2">
    <legend class="font-bold px-4">{{ 'Price Range' | translate }}</legend>
    <!-- Slider body -->
    <div id="price-range-body" class="px-4">
      <!-- Track container -->
      <div
        #trackContainer
        class="relative h-2 mx-2 my-4 cursor-pointer"
        (mousedown)="onTrackMouseDown($event)"
        role="presentation"
      >
        <!-- Background track -->
        <div class="absolute inset-0 rounded-full bg-base-300"></div>

        <!-- Active range fill -->
        <div
          class="absolute top-0 h-full rounded-full bg-primary"
          [style.left.%]="fillLeft()"
          [style.width.%]="fillWidth()"
        ></div>

        <!-- Min thumb -->
        <div
          #minThumb
          class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-base-100 border-2 border-primary shadow cursor-grab active:cursor-grabbing focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 transition-shadow hover:shadow-md"
          [style.left.%]="minPercent()"
          tabindex="0"
          role="slider"
          [attr.aria-label]="'Minimum price' | translate"
          [attr.aria-valuemin]="absMin()"
          [attr.aria-valuemax]="maxVal()"
          [attr.aria-valuenow]="minVal()"
          [attr.aria-valuetext]="'SYP ' + minVal()"
          (mousedown)="startDrag($event, 'min')"
          (keydown)="onKeyDown($event, 'min')"
        ></div>

        <!-- Max thumb -->
        <div
          #maxThumb
          class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-base-100 border-2 border-primary shadow cursor-grab active:cursor-grabbing focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 transition-shadow hover:shadow-md"
          [style.left.%]="maxPercent()"
          tabindex="0"
          role="slider"
          [attr.aria-label]="'Maximum price' | translate"
          [attr.aria-valuemin]="minVal()"
          [attr.aria-valuemax]="absMax()"
          [attr.aria-valuenow]="maxVal()"
          [attr.aria-valuetext]="'SYP ' + maxVal()"
          (mousedown)="startDrag($event, 'max')"
          (keydown)="onKeyDown($event, 'max')"
        ></div>
      </div>

      <!-- Price label -->
      <p class="text-sm text-base-content/70 mt-2">
        {{ 'Price' | translate }}:
        <span class="font-medium text-base-content">
          SYP {{ minVal() }} — {{ maxVal() }}
        </span>
      </p>
    </div>
  </fieldset>
  <menu class="collapse collapse-arrow">
    <input type="checkbox" checked />
    <div class="collapse-title font-bold">{{ 'Rating' | translate }}</div>
    <div class="collapse-content text-sm">
      <fieldset class="flex flex-col space-y-2">
        <label class="label text-base items-center text-black">
          <input
            type="checkbox"
            [checked]="ratingIsChecked(5)"
            class="checkbox checkbox-primary checkbox-sm rounded"
            (change)="toggleRatingFilterOption(5)"
          />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          5
        </label>

        <label class="label text-base items-center text-black">
          <input
            type="checkbox"
            [checked]="ratingIsChecked(4)"
            class="checkbox checkbox-primary checkbox-sm rounded"
            (change)="toggleRatingFilterOption(4)"
          />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-white-dark/90" />
          4+
        </label>
        <label class="label text-base items-center text-black">
          <input
            type="checkbox"
            [checked]="ratingIsChecked(3)"
            class="checkbox checkbox-primary checkbox-sm rounded"
            (change)="toggleRatingFilterOption(3)"
          />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          3+
        </label>
        <label class="label text-base items-center text-black">
          <input
            type="checkbox"
            [checked]="ratingIsChecked(2)"
            class="checkbox checkbox-primary checkbox-sm rounded"
            (change)="toggleRatingFilterOption(2)"
          />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          2+
        </label>
        <label class="label text-base items-center text-black">
          <input
            type="checkbox"
            [checked]="ratingIsChecked(1)"
            class="checkbox checkbox-primary checkbox-sm rounded"
            (change)="toggleRatingFilterOption(1)"
          />
          <sham-i-RatingStar class="text-yellow-400" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          <sham-i-RatingStar class="text-white-dark/90" />
          1+
        </label>
      </fieldset>
    </div>
  </menu>
</aside>
